namespace Matrix.Data {
    export class PartyRoleColumns {
        static columnsKey = 'Data.PartyRole';
    }
}
